/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { Avatar } from '@mui/material';
import { AIADMIN_PRIMARY_COLOR, AIADMIN_SURFACE_WHITE_HEX_COLOR } from '../../common/styles/aiadminThemeTokens';

/**
 * The signed-in admin's initials (the same "MV" as in the header profile), in an outlined circle like
 * the header's, so the admin's messages are easy to tell from Maven's filled navy avatar.
 */
const UserAvatar = ({ size, initials, fullName }) => (
  <Avatar
    alt={fullName || 'You'}
    sx={{
      width: size,
      height: size,
      fontSize: size * 0.4,
      fontWeight: 600,
      bgcolor: AIADMIN_SURFACE_WHITE_HEX_COLOR,
      color: AIADMIN_PRIMARY_COLOR,
      border: `2px solid ${AIADMIN_PRIMARY_COLOR}`
    }}
  >
    {initials || 'You'}
  </Avatar>
);

UserAvatar.propTypes = {
  size: PropTypes.number,
  initials: PropTypes.string,
  fullName: PropTypes.string
};

UserAvatar.defaultProps = { size: 28, initials: '', fullName: '' };

// Reads the same mobx `user` store as common/header/Profile.jsx. The function form keeps working
// (falls back to "You") when there is no store, e.g. in tests.
export default inject((stores) => ({
  initials: stores.user?.initials,
  fullName: stores.user?.fullName
}))(observer(UserAvatar));
